import React, { useState } from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { MailIcon } from 'lucide-react';
export const EmailSupport = () => {
  const [scrolled, setScrolled] = useState(false);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-7102">
      <Navbar scrolled={scrolled} data-id="element-7103" />
      <main className="pt-24 pb-20" data-id="element-7104">
        <div className="container mx-auto px-4 md:px-6" data-id="element-7105">
          <div className="max-w-3xl mx-auto bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm" data-id="element-7106">
            <div className="flex flex-col items-center text-center mb-8" data-id="element-7107">
              <div className="w-16 h-16 bg-[#2DB489]/10 rounded-full flex items-center justify-center mb-4" data-id="element-7108">
                <MailIcon className="h-8 w-8 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-7109" />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-7110">
                Contact Us via Email
              </h1>
              <p className="text-xl text-gray-600 dark:text-[#B0C1BD]" data-id="element-7111">
                Please send your inquiries to{' '}
                <a href="mailto:support@yourdomain.com" className="text-[#2DB489] dark:text-[#4ED1A0] hover:underline" data-id="element-7112">
                  support@yourdomain.com
                </a>
              </p>
              <p className="mt-4 text-gray-600 dark:text-[#B0C1BD]" data-id="element-7113">
                We typically respond within 24 hours.
              </p>
            </div>
            <div className="bg-gray-50 dark:bg-[#1A3330] rounded-lg p-6 mb-6" data-id="element-7114">
              <h2 className="text-xl font-semibold mb-3 text-gray-800 dark:text-[#F8FAF9]" data-id="element-7115">
                What to Include in Your Email
              </h2>
              <ul className="space-y-2 text-gray-600 dark:text-[#B0C1BD]" data-id="element-7116">
                <li className="flex items-start" data-id="element-7117">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7118">
                    •
                  </span>
                  <span data-id="element-7119">Your account email address</span>
                </li>
                <li className="flex items-start" data-id="element-7120">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7121">
                    •
                  </span>
                  <span data-id="element-7122">Order number (if applicable)</span>
                </li>
                <li className="flex items-start" data-id="element-7123">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7124">
                    •
                  </span>
                  <span data-id="element-7125">Detailed description of your issue or question</span>
                </li>
                <li className="flex items-start" data-id="element-7126">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7127">
                    •
                  </span>
                  <span data-id="element-7128">Screenshots (if relevant)</span>
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-lg p-6 text-white" data-id="element-7129">
              <h2 className="text-xl font-semibold mb-2" data-id="element-7130">Support Hours</h2>
              <p className="mb-4 opacity-90" data-id="element-7131">
                Our email support team is available during the following hours:
              </p>
              <div className="space-y-1 mb-4" data-id="element-7132">
                <div className="flex justify-between" data-id="element-7133">
                  <span data-id="element-7134">Monday - Friday:</span>
                  <span data-id="element-7135">9:00 AM - 6:00 PM ET</span>
                </div>
                <div className="flex justify-between" data-id="element-7136">
                  <span data-id="element-7137">Saturday:</span>
                  <span data-id="element-7138">10:00 AM - 4:00 PM ET</span>
                </div>
                <div className="flex justify-between" data-id="element-7139">
                  <span data-id="element-7140">Sunday:</span>
                  <span data-id="element-7141">Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-7142" />
    </div>;
};